module.exports = __webpack_public_path__ + "staticVue/img/login-icon.e43bec1d.png";